export const serverThemeFake = {
  palette: {
    mode: 'dark',
    background: {
      default: '#101828',
      surface: '#101828',
      hover: '#232A31',
      sidebar: '#101828'
    },
    primary: {
      200: '#FFFFFF08',
      800: '#1e1e1e',
      light: '#eef2f6',
      main: '#01C8E7',
      dark: '#1f344d'
    },
    secondary: {
      200: '#b39ddb',
      800: '#4527a0',
      light: '#90caf9',
      main: '#142332',
      dark: '#FFFFFF0A'
    },
    text: {
      primary: '#ffffff',
      secondary: '#697586'
    },
    divider: '#3a444b'
  }
}
